import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { SettingModel } from "@/model/setting/settingModel";
import service from "../baseHttpService";

class SettingService {
  DoGetSettingDetail() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakPayrollAPI.post("/api/setting/GetSettingDetail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoUpdateSetting(input: SettingModel) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakPayrollAPI.post("/api/setting/UpdateSetting", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetOnBoarding() {
    const _input = {
      merchantId: MerchantId(),
    };
    return service.peakPayrollAPI.post("/api/setting/GetOnBoarding", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdateOnBoarding(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: input,
    };
    return service.peakPayrollAPI.post("/api/setting/UpdateOnBoarding", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}
export default new SettingService();
